export default __webpack_public_path__ + "static/media/feather-calendar.f30dd0ee.svg";